module.exports = __webpack_public_path__ + "87fb8aa5f6a50fb3da24fdc75727cd6c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/imgs/brushes-cat.png
 ** module id = 596
 ** module chunks = 0
 **/